import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { Personalization } from "./pages";
import { RootProvider } from "./contexts";

import "./App.css";

function App() {
  return (
    <PrimeReactProvider
      value={{
        appendTo: "self",
      }}
    >
      <RootProvider>
        <Personalization />
      </RootProvider>
    </PrimeReactProvider>
  );
}

export default App;
